import {Ref, useEffect, useRef} from 'react';

export function useLegacyRef<T>(ref: Ref<T>) {
    const newRef = useRef<T>();

    useEffect(() => {
        if (!ref) {
            return;
        }

        if (typeof ref === 'function') {
            ref(newRef.current);
        }
    });

    return newRef;
}
